__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "nbly-documents";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(926), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(926), __webpack_require__.e(519), __webpack_require__.e(860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/icons-material", "5.18.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(220), __webpack_require__.e(789), __webpack_require__.e(926), __webpack_require__.e(519), __webpack_require__.e(999)]).then(() => (() => (__webpack_require__(4789))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(220), __webpack_require__.e(928), __webpack_require__.e(283), __webpack_require__.e(926), __webpack_require__.e(884), __webpack_require__.e(519), __webpack_require__.e(999)]).then(() => (() => (__webpack_require__(9283))))));
			register("@neighborly-software/components", "0.4.8", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(220), __webpack_require__.e(446), __webpack_require__.e(926), __webpack_require__.e(884), __webpack_require__.e(519), __webpack_require__.e(999), __webpack_require__.e(921)]).then(() => (() => (__webpack_require__(7446))))));
			register("@neighborly-software/skip-to-content", "0.1.0", () => (Promise.all([__webpack_require__.e(86), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(3086))))));
			register("@syncfusion/ej2-base", "26.2.10", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(2344))))));
			register("@syncfusion/ej2-react-pdfviewer", "26.2.14", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(926), __webpack_require__.e(884), __webpack_require__.e(314)]).then(() => (() => (__webpack_require__(8416))))));
			register("@tanstack/react-query", "5.90.11", () => (Promise.all([__webpack_require__.e(40), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(2040))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(926), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("zustand", "4.5.7", () => (Promise.all([__webpack_require__.e(926), __webpack_require__.e(621)]).then(() => (() => (__webpack_require__(1621))))));
			initExternal(6012);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};